import { Country } from "@lookiero/sty-psp-locale";
import { LOCALE, DEFAULT_LOCALE } from "../../shared/config";

const formatDate = (date: string, countryCode: Country): string => {
  const locale = LOCALE[countryCode] || DEFAULT_LOCALE;
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(new Date(date));
};

export { formatDate };
